module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/manage.6c246342.jpg";